module.exports = __webpack_public_path__ + "img/Druid.13360508.png";